// removed by extract-text-webpack-plugin
module.exports = {"content":"index__content--2UQnE","image":"index__image--1BsIE","title":"index__title--2hJzv","description":"index__description--2chdK","button":"index__button--1yJjB"};


//////////////////
// WEBPACK FOOTER
// ./src/client/shared-components/OverviewNullState/styles/index.scss
// module id = l6vO
// module chunks = 23